import React, { useState } from 'react';
import './ThinkingBlock.css';

interface ThinkingBlockProps {
  content: string;
  isStreaming?: boolean;
}

const ThinkingBlock: React.FC<ThinkingBlockProps> = ({ content, isStreaming = false }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  
  // Parse the content to extract thinking parts
  const lines = content.split('\n');
  const preview = lines.slice(0, 2).join(' ').substring(0, 100) + (lines.length > 2 || content.length > 100 ? '...' : '');
  
  return (
    <div className={`thinking-block ${isStreaming ? 'streaming' : ''} ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="thinking-header" onClick={() => setIsCollapsed(!isCollapsed)}>
        <span className="thinking-icon">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <path d="M12 6v6l4 2"/>
          </svg>
        </span>
        <span className="thinking-label">Assertion's Analysis</span>
        {isStreaming && <span className="thinking-streaming-indicator">Processing...</span>}
        <button className="thinking-toggle" aria-label={isCollapsed ? 'Expand' : 'Collapse'}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points={isCollapsed ? "9 18 15 12 9 6" : "6 9 12 15 18 9"}/>
          </svg>
        </button>
      </div>
      
      {isCollapsed ? (
        <div className="thinking-preview">{preview}</div>
      ) : (
        <div className="thinking-content">
          <pre>{content}</pre>
        </div>
      )}
    </div>
  );
};

export default ThinkingBlock;